module.exports = __webpack_public_path__ + "files/bc8642fe77c612f88fc3165a4d9bb9c0.png";